import WanIpRequester from "../components/WanipForm/WanipForm.js";

import React from 'react'

function Wanip() {
  return (
    <div><WanIpRequester/></div>
  )
}

export default Wanip